import o from "./highrise606.mjs";
/* empty css             */
import t from "./highrise181.mjs";
const r = /* @__PURE__ */ t(o, [["__scopeId", "data-v-aa06f2fb"]]);
export {
  r as default
};
